<template>
  <div id="app">
    <Navbar />
    <router-view class="app-container"/>
    <notifications position="bottom right" group="success" />
  </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import {mapActions} from "vuex";

  export default {
    name: 'App',
    components: {
      Navbar,
    },
    methods: {
      ...mapActions('security', ['init']),
    },
    created() {
      this.init()
    }
  }
</script>

<style lang="scss">
  @import 'assets/css/element';
  @import 'assets/css/var.css';
  body {
    margin: 0;
    font-family: sans-serif;
  }

  #app{
    display: flex;
    width: 100%;
    min-height: 100vh;
  }

  .app-container{
    width: 100%;
    padding-left: 30px;
  }

</style>
